const angular = require('angular');
var app = angular.module('learn-resources');
/**
 * Analyze managers Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('FroalaOptions', ['$resource', 'Application', 'Authorization', function ($resource, Application) {
  var self = this;
  var globalOptions = {
    key: '4NC5fF6A3D4H3H3C4B-16UJHAEFZMUJOYGYQEa2d2ZJd1RAeF3C8B5C4E3C3B2G3A14A7==',
    charCounterCount: false,
    attribution: false,
    imageDefaultAlign: 'left',
    imageAllowedTypes: ['jpeg', 'jpg', 'png', 'gif', 'svg+xml', 'pcd', 'jp2', 'jpx'],
    imageUploadURL: 'files/editor-image',
    imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
    imageStyles: {
      "fr-rounded": 'Rounded',
      "fr-bordered": 'Bordered',
      "fr-shadow": 'Shadow',
      "fr-centered": 'Centered',
      "fr-imgBullet": 'Bullet'
    },
    fontSize: ['8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18','19','20','21', '22', '24', '26', '30','36', '48', '60', '72', '96'],
    fontSizeDefaultSelection: Application.froalaConfig.baseFontSize,
    linkInsertButtons: ['linkBack'],
    pasteAllowedStyleProps: Application.froalaConfig.pasteAllowedStyleProps,
    pasteDeniedAttrs: Application.froalaConfig.pasteDeniedAttrs,
    htmlUntouched: true,
    htmlAllowedStyleProps: ['font-family', 'font-size', 'background', 'color', 'width', 'text-align', 'vertical-align', 'background-color'],
    htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'allow', 'allowfullscreen', 'allowtransparency', 'alt', 'aria-.*', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'frameborder', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'mozallowfullscreen', 'multiple', 'muted', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'webkitallowfullscreen', 'width', 'wrap'],
    paragraphStyles: {
      'fr-text-title': 'Title',
      'fr-text-gray': 'Gray',
      'fr-text-branded': 'Branded',
      'fr-text-bordered': 'Bordered',
      'fr-text-spaced': 'Spaced',
      'fr-text-uppercase': 'Uppercase'
    },
    inlineClasses: {
      'fr-class-code': 'Code',
      'fr-class-code-dark': 'Dark',
      'fr-class-highlighted': 'Highlighted',
      'fr-class-transparency': 'Transparent'
    },
    tableStyles: {
      'fr-dashed-borders': 'Dashed Borders',
      'fr-alternate-rows': 'Alternating Rows',
      'fr-fluid-width': 'Fluid Width'
    },
    colorsBackground: Application.froalaConfig.colors,
    colorsText: Application.froalaConfig.colors,
    emoticonsUseImage: false,
    emoticonsStep: 10,
    emoticonsSet: [
      {
        id: 'people',
        name: 'Smileys & People',
        code: '1f600',
        emoticons: [
          {
            code: "1F601",
            desc: "Beaming face with smiling eyes"
          },
          {
            code: "1F603",
            desc: "Grinning face with big eyes"
          },
          {
            code: "1F602",
            desc: "Face with tears of joy"
          },
          {
            code: "1F60D",
            desc: "Smiling face with heart eyes"
          },
          {
            code: "1F60A",
            desc: "Smiling face with blush"
          },
          {
            code: "1F60E",
            desc: "Smiling face with sunglasses "
          },
          {
            code: "1F609",
            desc: "Winking face"
          },
          {
            code: "1F923",
            desc: "Rolling on the floor laughing "
          },
          {
            code: "1F618",
            desc: "Face blowing a kiss"
          },
          {
            code: "1F605",
            desc: "Grinning face with sweat "
          },
          {
            code: "1F606",
            desc: "Grinning squinting face"
          },
          {
            code: "1F60B",
            desc: "Face savoring food"
          },
          {
            code: "1F917",
            desc: "Hugging face"
          },
          {
            code: "1F914",
            desc: "Thinking face"
          },
          {
            code: "1F610",
            desc: "Neutral face"
          },
          {
            code: "1F611",
            desc: "Expressionless face"
          },
          {
            code: "1F644",
            desc: "Face with rolling eyes "
          },
          {
            code: "1F60F",
            desc: "Smirking face"
          },
          {
            code: "1F634",
            desc: "Sleeping face"
          },
          {
            code: "1F60C",
            desc: "Relived face"
          },
          {
            code: "1F62B",
            desc: "Tired Face"
          },
          {
            code: "1F634",
            desc: "Sleeping face"
          },
          {
            code: "1F61B",
            desc: "Face with tongue"
          },
          {
            code: "1F61C",
            desc: "Winking face with tongue "
          },
          {
            code: "1F61D",
            desc: "Squinting face with tongue"
          },
          {
            code: "1F612",
            desc: "Unamused face"
          },
          {
            code: "1F614",
            desc: "Pensive face"
          },
          {
            code: "1F614",
            desc: "Confused face"
          },
          {
            code: "1F643",
            desc: "Upside down face"
          },
          {
            code: "1F61E",
            desc: "Disappointed face"
          },
          {
            code: "1F61F",
            desc: "Face with steam from nose"
          },
          {
            code: "1F62D",
            desc: "Loudly crying face"
          },
          {
            code: "1F629",
            desc: "Weary face"
          },
          {
            code: "1F92F",
            desc: "Exploding head"
          },
          {
            code: "1F62C",
            desc: "Grimacing face"
          },
          {
            code: "1F630",
            desc: "Anxious face with sweat"
          },
          {
            code: "1F631",
            desc: "Face screaming in fear "
          },
          {
            code: "1F633",
            desc: "Flushed face"
          },
          {
            code: "1F621",
            desc: "Pouting face"
          },
          {
            code: "1F620",
            desc: "Angry Face"
          },
          {
            code: "1F637",
            desc: "Face with medical mask "
          },
          {
            code: "1F913",
            desc: "Nerd face"
          },
          {
            code: "1F608",
            desc: "Smiling face with horns "
          },
          {
            code: "1F47F",
            desc: "Angry face with horns "
          },
          {
            code: "1F480",
            desc: "Skull"
          },
          {
            code: "1F4A9",
            desc: "Pile of poo"
          },
          {
            code: "1F648",
            desc: "See no evil monkey"
          },
          {
            code: "1F649",
            desc: "Hear no evil monkey"
          },
          {
            code: "1F64A",
            desc: "Speak no evil monkey"
          }
        ]
      },

      {
        id: 'gestures',
        name: 'Gestures',
        code: '1F44D',
        emoticons: [

          {
            code: "1F4AA",
            desc: "Flexed biceps"
          },
          {
            code: "1F448",
            desc: "Backhand index pointing left"
          },
          {
            code: "1F449",
            desc: "Backhand index pointing right"
          },
          {
            code: "270C",
            desc: "Victory hand"
          },
          {
            code: "270B",
            desc: "Raised Hand"
          },
          {
            code: "1F44C",
            desc: "Ok Hand"
          },
          {
            code: "1F44D",
            desc: "Thumbs Up"
          },
          {
            code: "1F44E",
            desc: "Thumbs Down"
          },
          {
            code: "1F44A",
            desc: "Oncoming fist"
          },
          {
            code: "1F44B",
            desc: "Waving hand"
          },
          {
            code: "1F44F",
            desc: "Clapping hands"
          },
          {
            code: "1F64C",
            desc: "Raising Hands"
          },
          {
            code: "1F64F",
            desc: "Folded hands"
          },
          {
            code: "1F440",
            desc: "Eyes "
          }
        ]
      },
      {
        id: 'things',
        name: 'Things',
        code: '1F4AC',
        emoticons: [

          {
            code: "1F495",
            desc: "Two Hearts"
          },
          {
            code: "2764",
            desc: "Red heart"
          },
          {
            code: "1F4A5",
            desc: "Collision"
          },
          {
            code: "1F4AC",
            desc: "Speech balloon"
          },
          {
            code: "1F451",
            desc: "Crown "
          },
          {
            code: "1F3A9",
            desc: "Top Hat"
          },
          {
            code: "2615",
            desc: "Hot beverage"
          },
          {
            code: "1F37A",
            desc: "Beer mug"
          },
          {
            code: "1F680",
            desc: "Rocket "
          },
          {
            code: "23F0",
            desc: "Alarm Clock"
          },
          {
            code: "2600",
            desc: "Sun"
          },
          {
            code: "1F525",
            desc: "Fire "
          },
          {
            code: "2728",
            desc: "Sparkles "
          },
          {
            code: "1F389",
            desc: "Party Popper"
          },
          {
            code: "1F3AF",
            desc: "Direct Hit"
          },
          {
            code: "1F4AF",
            desc: "Hundred points"
          },
          {
            code: "2714",
            desc: "Heavy check mark "
          }
          ]
      }
    ]
  };
  return globalOptions;
}]);